import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { api_without_cancellation } from "@/api/api";

export const GLOBAL_PAGES_CACHE_DURATION = 20 * 60 * 1000;
const GLOBAL_PAGES_REQUEST_TIMEOUT = 30_000;

export const fetchAllPages_New = createAsyncThunk(
  "allPages/fetchAllPages",
  async (url, { signal }) => {
    const response = await api_without_cancellation.get(url || "/api/litigation-page/get-pages/", {
      signal,
      timeout: GLOBAL_PAGES_REQUEST_TIMEOUT,
    });
    return response.data;
  },
  {
    // Several screens can ask for this shared list at the same time. One
    // in-flight request is enough and prevents duplicate pending XHRs.
    condition: (_url, { getState }) => getState().allPages?.status !== "loading",
  }
);

const initialState = {
  allPages: [],
  status: "idle",
  loading: true,
  error: null,
  lastFetched: null,
};

const allPagesSlice = createSlice({
  name: "allPages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPages_New.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPages_New.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allPages = action.payload;
        state.loading = false;
        state.lastFetched = Date.now();
      })
      .addCase(fetchAllPages_New.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default allPagesSlice.reducer;
